import React from 'react'
export const LoadingSpinner: React.FC = () => (
  <div className="text-center loading-spinner">
    <img src="/wp-content/themes/stadtmagazin/assets/images/loading.png" alt="Loading…" />
  </div>
)
